import { call, put, takeLatest } from "redux-saga/effects";
import types from "./types";
import apiClientFactory from "../../backend/apiClient";
import endPoint from "../../backend/endpoints";

//get
function* getTechnicalDocumentHandlerSaga(action) {
	const apiClient = apiClientFactory();
	try {
		const { data } = yield call(
			apiClient.get,
			endPoint.dynamicList({ path: "TechnicalDocument", ...action.payload }),
		);
		yield put({
			type: types.GET_TECHNICALDOCUMENT_SUCCESS,
			payload: data.response,
		});
	} catch (e) {
		const payload = e?.response?.data || e;
		yield put({
			type: types.GET_TECHNICALDOCUMENT_ERROR,
			payload,
		});
	}
}

export function* getTechnicalDocumentWatcherSaga() {
	yield takeLatest(types.GET_TECHNICALDOCUMENT_START, getTechnicalDocumentHandlerSaga);
}

//create

//delete

function* deleteTechnicalDocumentHandlerSaga(action) {
	const apiClient = apiClientFactory();
	try {
		const { data } = yield call(
			apiClient.delete,
			endPoint.deleteDyanamicItem("TechnicalDocument", action.payload),
		);
		yield put({
			type: types.DELETE_TECHNICALDOCUMENT_SUCCESS,
			payload: data,
		});
	} catch (e) {
		const payload = e?.response?.data || e;
		yield put({
			type: types.DELETE_TECHNICALDOCUMENT_ERROR,
			payload,
		});
	}
}

export function* deleteTechnicalDocumentWatcherSaga() {
	yield takeLatest(
		types.DELETE_TECHNICALDOCUMENT_START,
		deleteTechnicalDocumentHandlerSaga,
	);
}

//update
